(function ($) {
	'use strict';

	$.contrast = {
		init: function () {
			var contrastSwitcher = $('#contrastswitcher');

			if (contrastSwitcher) {
				var buttonState
				initTheme();

				contrastSwitcher.on('click', function (e) {
					resetTheme(e);
				});

				function initTheme() {
					var contrastThemeSelected = (localStorage.getItem('contrast') !== null && localStorage.getItem('contrast') === 'on');
					if (!contrastThemeSelected) {
						contrastSwitcher.attr('aria-pressed','false');
					} else {
						contrastSwitcher.attr('aria-pressed','true');
					}
					buttonState = contrastThemeSelected;
					contrastThemeSelected ? $('body').attr('data-theme', 'contrast') : $('body').removeAttr('data-theme');
				}

				function resetTheme(e) {
					buttonState = $(e.target).attr('aria-pressed') === 'true';
					if (!buttonState) {
						contrastSwitcher.attr('aria-pressed','true');
						$('body').attr('data-theme', 'contrast');
						localStorage.setItem('contrast', 'on');
					} else {
						contrastSwitcher.attr('aria-pressed','false');
						$('body').removeAttr('data-theme');
						localStorage.removeItem('contrast');
					}
				}
			}
		}
	}
})(jQuery);
